import constant from './constant'

export default {
  buildTenantUrl() {
    const tenant = window.localStorage.getItem('vitale-subdomain')

    return constant.apiBaseURL.replace('{tenant}', tenant)
  }
}
